import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const ReportsIntro = () => {
  const { t } = useTranslation();

  return (
    <Container fluid className="py-5 reports-intro-docs">
      <Row className="justify-content-center mb-4">
        <Col lg={8}>
          <Card className="shadow-sm border-0 rounded-lg p-4">
            <Card.Body>
              {/* Title */}
              <Card.Title className="display-6 mb-3">
                {t("documentation.reports.intro.title")}
              </Card.Title>

              {/* Description */}
              <Card.Text className="text-muted mb-3">
                {t("documentation.reports.intro.description")}
              </Card.Text>

              {/* Subchapters */}
              <h5 className="fw-semibold mt-4 mb-2">
                {t("documentation.reports.intro.subchaptersTitle")}
              </h5>
              <ul className="overview-list">
                <li>{t("documentation.reports.intro.subchapters.single")}</li>
                <li>
                  {t("documentation.reports.intro.subchapters.automated")}
                </li>
                <li>{t("documentation.reports.intro.subchapters.history")}</li>
              </ul>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ReportsIntro;
